import { render, staticRenderFns } from "./BidSubject.vue?vue&type=template&id=554e5442&scoped=true&"
import script from "./BidSubject.vue?vue&type=script&lang=js&"
export * from "./BidSubject.vue?vue&type=script&lang=js&"
import style0 from "./BidSubject.vue?vue&type=style&index=0&id=554e5442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e5442",
  null
  
)

export default component.exports